import { Certificate, ICertificate } from '../certificate';

export interface IMedicalAndVaccination {
  medical_certificates?: ICertificate[];
  vaccination?: ICertificate[];
}

export class MedicalAndVaccination {
  medical_certificates: Certificate[];
  vaccination: Certificate[];

  constructor( data: IMedicalAndVaccination = {} ) {
    this.medical_certificates = data.medical_certificates
      ? data.medical_certificates.map(( cert ) => new Certificate(cert))
      : [];
    this.vaccination = data.vaccination
      ? data.vaccination.map(( cert ) => new Certificate(cert))
      : [];
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/medical-and-vaccination.ts